const availableFonts = [
  'Anton', 'Be Vietnam Pro', 'Bitter', 'Chakra Petch', 'Hahmlet',
  'Inconsolata', 'Inter', 'Kosugi', 'Lato', 'Lora', 'M PLUS 1 Code',
  'Montserrat', 'Noto Sans', 'Noto Serif', 'Nunito', 'Open Sans',
  'PT Sans', 'PT Serif', 'Pridi', 'Raleway', 'Roboto',
  'Roboto Slab', 'Shadows Into Light', 'Source Sans Pro', 'Titillium Web',
  'Ubuntu Mono',
]

// Not google fonts
// 'Arial'
const loadedWebFonts = [
  'Anton', 'Be Vietnam Pro', 'Bitter', 'Chakra Petch', 'Hahmlet',
  'Inconsolata', 'Inter', 'Kosugi', 'Lato', 'Lora', 'M PLUS 1 Code',
  'Montserrat', 'Noto Sans', 'Noto Serif', 'Nunito', 'Open Sans',
  'PT Sans', 'PT Serif', 'Pridi', 'Raleway', 'Roboto',
  'Roboto Slab', 'Shadows Into Light', 'Source Sans Pro', 'Titillium Web',
  'Ubuntu Mono',
]

const headlineFontSizes = [
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '22px',
  '24px',
  '26px',
  '28px',
  '32px',
  '36px',
  '40px',
  '48px',
  '56px']

const textFontSizes = [
  '12px',
  '13px',
  '14px',
  '15px',
  '16px',
  '17px',
  '18px',
  '20px',
  '22px',
  '24px',
  '26px']

const buttonFontSizes = [
  '12px',
  '13px',
  '14px',
  '15px',
  '16px',
  '17px',
  '20px',
  '22px']

const textAlign = ['left', 'center', 'right']

const flexBoxAlign = [
  { label: 'Left', value: 'flex-start' },
  { label: 'Center', value: 'center' },
  { label: 'Right', value: 'flex-end' },
]

export {
  availableFonts,
  loadedWebFonts,
  textFontSizes,
  buttonFontSizes,
  headlineFontSizes,
  textAlign,
  flexBoxAlign,
}
